import { createSlice } from '@reduxjs/toolkit';

const initialState: IErrorState = {
  error: {
    id: null,
  }
};

export const errorSlice = createSlice({
  name: 'error',
  initialState,
  reducers: {
    setError(state, {payload}: {payload: ErrorData}) {
      return { ...state, error: payload }
    },
    clearError() {
      return initialState;
    }
  }
});

export const {
  setError,
  clearError
} = errorSlice.actions

export const getError = (state: IReducerStates) => state.error;
